import SVGIconWrapper from "./SVGIconWrapper"

const IconCheckmarkCircle = (props) => (
    <SVGIconWrapper
        fill={props.fill ?? "#000000"}
        style={props.style}
        viewBox="0 0 45.4 45.4"
        iconClass={`icon--checkmark-circle ${props.iconClass}`}
        wrapperClass={props.wrapperClass}
        onClick={props.onClick}
    >
        <g><path d="M18.9,32.6L18.9,32.6c-0.3,0-0.5-0.1-0.7-0.3L10,24.1c-0.4-0.4-0.4-1.1,0-1.4c0.4-0.4,1.1-0.4,1.4,0l7.5,7.5L34,15.1c0.4-0.4,1-0.4,1.4,0s0.4,1,0,1.4L19.6,32.3C19.4,32.5,19.1,32.6,18.9,32.6z" /><path d="M22.7,0C10.2,0,0,10.2,0,22.7c0,12.5,10.2,22.7,22.7,22.7c12.5,0,22.7-10.2,22.7-22.7C45.4,10.2,35.2,0,22.7,0z M42.8,22.7c0,11.1-9,20.1-20.1,20.1s-20.1-9-20.1-20.1s9-20.1,20.1-20.1S42.8,11.6,42.8,22.7z" /></g>
    </SVGIconWrapper>
)

export default IconCheckmarkCircle